import React from 'react';
import { createPortal } from 'react-dom';
import { useIntl } from 'react-intl';
import { Button } from 'Components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { UNLOCK_DOOR } from '../constants';

const TEXT_KEYS = {
	LOCK_DOOR: { title: 'oemDataModal_remote_confirmLockTitle', body: 'oemDataModal_remote_confirmLockBody' },
	UNLOCK_DOOR: { title: 'oemDataModal_remote_confirmUnlockTitle', body: 'oemDataModal_remote_confirmUnlockBody' },
};

/**
 * Confirmation for a door command, portal'd to the body above the OEM modal.
 * Names the vehicle; unlocking also warns that it will be accessible.
 * Renders nothing while `command` is null.
 */
export const ConfirmRemoteCommandDialog = ({ command, vehicleName, onConfirm, onCancel }) => {
	const { messages, formatMessage } = useIntl();
	if (!command) return null;
	const keys = TEXT_KEYS[command];

	return createPortal(
		<Modal
			open
			size="small"
			title={messages[keys.title]}
			handleClose={onCancel}
			onClose={onCancel}
			className="oem-remote-confirm"
		>
			<ModalBody>
				<div className="oem-remote-confirm-body">
					<p>{formatMessage({ id: keys.body }, { name: vehicleName })}</p>
					{command === UNLOCK_DOOR && (
						<p className="oem-remote-confirm-warning" role="alert">
							{messages['oemDataModal_remote_unlockWarning']}
						</p>
					)}
				</div>
			</ModalBody>
			<ModalFooter>
				<div className="oem-remote-confirm-actions">
					<Button className="btn-cancel" onClick={onCancel}>
						{messages['oemDataModal_remote_cancel']}
					</Button>
					<Button className="btn-blue" onClick={onConfirm}>
						{messages['oemDataModal_remote_send']}
					</Button>
				</div>
			</ModalFooter>
		</Modal>,
		document.body,
	);
};
